import BaseTable, { ColumnType } from "../../../components/elements/BaseTable"
import { Tour } from "../types"
import TourTableRow from "./TourTableRow"

type TourTableType = {
    tours: Tour[]
    deleteTour: (id: string) => void
}

export default function TourTable(props: TourTableType) {
    const columns: ColumnType[] = [
        { label: "Tour" },
        { label: "Mitarbeiter" },
        { label: "Objekte" },
        { label: "Mo–Fr", responsive: "hidden lg:table-cell" },
        { label: "Status" },
        { label: "" },
    ]

    return (
        <BaseTable
            columns={columns}
            tbody={props.tours.map((tour) => (
                <TourTableRow key={tour._id} tour={tour} deleteTour={props.deleteTour} />
            ))}
        />
    )
}
